<template>
  <el-dialog
    class="database_creator"
    title="新建数据库"
    width="540px"
    top="25vh"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
    @closed="onDialogClosed"
  >
    <el-form label-width="108px" ref="form" :model="form" :rules="rules">
      <el-form-item label="数据库名称" prop="databaseName">
        <el-input placeholder="请输入数据库名称" v-model="form.databaseName"></el-input>
      </el-form-item>
      <el-form-item label="集合名称" prop="collectionName">
        <el-input placeholder="请输入集合名称" v-model="form.collection"></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="isVisible = false">关闭</el-button>
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { reqCreateDatabase } from '@/api/mongodb';
import Validator from '@/utils/Validator';
import Store from '@/store/index';

export default {
  name: 'CollectionCreator',

  data() {
    const databaseNameValidator = (rule, value, callback) => {
      const validator = new Validator(rule, value, callback);
      validator
        .register(validator.isStandardStr())
        .register(validator.lenRange(1, 65, `数据库名的长度不能超过 64 个字符`))
        .validate();
    };

    return {
      isVisible: false,
      form: {
        databaseName: '',
        collection: ''
      },
      rules: {
        databaseName: [
          { required: true, message: '请输入数据库名称', trigger: ['blur', 'change'] },
          { validator: databaseNameValidator, trigger: ['blur', 'change'] }
        ]
      }
    };
  },

  methods: {
    open() {
      this.isVisible = true;
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          this.$message.warning('请完成所有表单项');
          return;
        }

        try {
          if(this.form.collection === ''){
            this.form.collection = undefined;
          }
          let data = {
            ConnToken: Store.getters['source/connToken'],
            DataBase: this.form.databaseName,
            Collection: this.form.collection
          }
          let res = await reqCreateDatabase(data);
          if(res.data.data){
            this.$message.success('创建成功');
            this.isVisible = false;
            this.$emit('submit', true);
          }
        } catch (e) {
          this.$emit('submit', false);
        }
      });
    },
    onDialogClosed() {
      this.form.databaseName = '';
      this.form.collection = '';
      this.$refs.form.resetFields();
    }
  }
};
</script>
